// Copyright ©️ 2026 eVolve MEP, LLC

import { useState } from 'react';

import { Button } from '@mantine/core';

import { getActionButtonProps } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/common';
import type { WorkOrderActionButtonsProps } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/WorkOrderActionButtons';
import { useWorkOrders } from 'modules/Shop/WorkOrders/WorkOrdersPage/useWorkOrders';

export const ApproveWorkOrderButton = ({ workOrder, onWorkOrderActioned, ...props }: WorkOrderActionButtonsProps) => {
  const { approveWorkOrder } = useWorkOrders();
  const [saving, setSaving] = useState(false);

  const onSubmit = () => {
    setSaving(true);
    void approveWorkOrder(workOrder.workOrderId)
      .then(onWorkOrderActioned)
      .finally(() => setSaving(false));
  };

  return (
    <Button onClick={onSubmit} loading={saving} {...getActionButtonProps(props)}>
      Approve
    </Button>
  );
};
